<div *ngIf="avaliacaoList && avaliacaoList.length > 0" id="avaliacoesCont">
    <div id="avaliacoesFixed">
        <div id="avaliacaoGraph">
            <!-- <div id="canvasCont">
                <canvas baseChart
                    [data]="doughnutChartData"
                    [labels]="doughnutChartLabels"
                    [chartType]="doughnutChartType"
                    [options]="doughnutChartOption"
                    [colors]="doughnutChartColors">
                </canvas>
            </div> -->
            <div id="canvasCont"><img src="assets/svg/nps.svg" alt="" /></div>
            <div *ngIf="nps <= 0" [style.background]="'rgb(255, 115, 115)'" id="npsNumber">
                <span>{{nps | number:'1.0-0'}}</span>
                <h4>NPS</h4>
                <div [style.transform]="'rotate(' + (nps*1.22) + 'deg)'" id="centerPointer">
                    <img id="pointer" src="assets/img/pointer-red.svg" alt="" />
                </div>
            </div>
            <div *ngIf="nps > 0 && nps <= 60" [style.background]="'rgb(255, 191, 45)'" id="npsNumber">
                <span>{{nps | number:'1.0-0'}}</span>
                <h4>NPS</h4>
                <div [style.transform]="'rotate(' + (nps*0.6333) + 'deg)'" id="centerPointer">
                    <img id="pointer" src="assets/img/pointer-yellow.svg" alt="" />
                </div>
            </div>
            <div *ngIf="nps > 60" [style.background]="'rgb(0, 201, 151)'" id="npsNumber">
                <span>{{nps | number:'1.0-0'}}</span>
                <h4>NPS</h4>
                <div [style.transform]="'rotate(' + (nps*1.22) + 'deg)'" id="centerPointer">
                    <img id="pointer" src="assets/img/pointer-green.svg" alt="" />
                </div>
            </div>
        </div>
        <div id="avaliacoesContList">
            <h2>Avalição dos consumidores</h2>
            <div *ngFor="let avaliacao of avaliacaoList" class="line">
                <div class="photoCont">
                    <div class="photoCut">
                        <img *ngIf="avaliacao.photo" src="{{avaliacao.photo}}" alt="" />
                        <span class="noFoto" *ngIf="!avaliacao.photo">{{avaliacao.nome.charAt(0).toUpperCase()}}</span>
                    </div>
                    <div *ngIf="avaliacao.nps <= 6" [style.background]="'rgb(255, 115, 115)'" class="photoNumber">
                        {{avaliacao.nps}}
                    </div>
                    <div *ngIf="avaliacao.nps >= 7 && avaliacao.nps <= 8" [style.background]="'rgb(255, 191, 45)'" class="photoNumber">
                        {{avaliacao.nps}}
                    </div>
                    <div *ngIf="avaliacao.nps >= 9" [style.background]="'rgb(0, 201, 151)'" class="photoNumber">
                        {{avaliacao.nps}}
                    </div>
                </div>
                <div class="textCont">
                    <h4 title="{{avaliacao.nome}}">{{avaliacao.nome}}</h4>
                    <p title="{{avaliacao.descricao}}">{{avaliacao.descricao}}</p>
                    <span *ngIf="transformDate(avaliacao.dt_cadastro) !== 0">{{transformDate(avaliacao.dt_cadastro)}} </span>
                    <span class="day" *ngIf="transformDate(avaliacao.dt_cadastro) === 0">hoje</span>
                    <span class="day" *ngIf="transformDate(avaliacao.dt_cadastro) === 1">dia</span>
                    <span class="day" *ngIf="transformDate(avaliacao.dt_cadastro) > 1">dias</span>
                </div>
            </div>
            <div (click)="openGraphScreen()" id="linkToAvaliacoes">
                Exibir avaliações >
            </div>
        </div>
    </div>
</div>
